<template>
	<div class="foot-box foot">
		<div class="foot-link">
			<!-- <router-link to="/us" tag="a" target="_blank" class="normal">关于我们</router-link> -->
			<span @click="handRou('us')" class="normal">关于我们</span>
			<span>|</span>
			<!-- <router-link to="/contact" tag="a" target="_blank" class="normal">联系我们</router-link> -->
			<span @click="handRou('contact')" class="normal">联系我们</span>

			<span>|</span>
			<!-- <router-link to="/notices" tag="a" target="_blank" class="normal"
				>法律声明</router-link> -->
			<span @click="handRou('notices')" class="normal">法律声明</span>

			<span>|</span>
			<!-- <router-link to="/privacy" tag="a" target="_blank" class="normal"
				>隐私与条款</router-link> -->

			<span @click="handRou('privacy')" class="normal">隐私与条款</span>

			<span>|</span>
			<!-- <router-link to="/recruitment" tag="a" target="_blank" class="normal"
				>人才招聘</router-link
			> -->
			<span @click="handRou('recruitment')" class="normal">人才招聘</span>
			<span>|</span>
			<!-- <router-link to="/recruitment" tag="a" target="_blank" class="normal"
				>人才招聘</router-link
			> -->
			<span @click="handRou('convention')" class="normal">平台公约</span>

			<!-- <a href="/foot-about-us" target="_blank">关于我们</a> <span>|</span>
      <a href="/foot-contact-us" target="_blank">联系我们</a> <span>|</span>
      <a href="/foot-legal-notices" target="_blank">法律声明</a> <span>|</span>
      <a href="/foot-privacy-terms" target="_blank">隐私与条款</a>
      <span>|</span> <a href="/foot-recruitment" target="_blank">人才招聘</a> -->
		</div>
		<div class="copyright">
			<a
				target="_blank"
				href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010902002051"
				><img src="@/assets/gongan.png" />
				<span class="normal"> 苏公网安备 32020602001392号</span></a
			>
			<a target="_blank" href="https://beian.miit.gov.cn" class="normal"
				>苏ICP备19037356号-5</a
			>
			<span>苏B2-20220782</span>
			<!-- <span>(苏)字第0xxxx号</span> -->
			<span>Copyright 苏广科技版权所有</span>
		</div>
		<el-dialog
			custom-class="sg-login-dialog"
			:visible.sync="dialogVisible"
			title="请先登录"
			width="400px"
		>
			<login @closeLoginDialog="dialogVisible = false"></login>
		</el-dialog>
	</div>
</template>
<script>
import Login from "@/components/Login"

export default {
	components: {
		Login
	},
	data() {
		return {
			dialogVisible: false
		}
	},
	methods: {
		handRou(v) {
			console.log(v)
			if (v == "contact") this.$router.push("/contact")

			// } else {
			this.$router.push({
				path: `/${v}`
			})

			// this.$router.push({
			// 	path: `/${v}`,
			// })

			// }
		},
		handleLogin() {
			this.dialogVisible = true
		}
	}
}
</script>
<style lang="scss" scoped>
.normal:hover {
	color: #ff4f1a;
	cursor: pointer;
}

.foot {
	padding: 12px 0;
	// color: #666;
	// background-color: #282930;
	background: rgba(29, 32, 137, 1);
	color: rgba(255, 255, 255, 1);

	.foot-link {
		font-size: 14px;
		line-height: 20px;
		text-align: center;

		> span {
			margin: 0 14px;
		}
	}

	.copyright {
		margin-top: 8px;
		line-height: 20px;
		text-align: center;

		> a {
			margin: 0 5px;
			-webkit-transition: color 0.2s ease;
			transition: color 0.2s ease;
		}

		> span {
			margin: 0 3px;
		}
	}
}
</style>
